// extracted by mini-css-extract-plugin
module.exports = {"whereContainer":"WherePage_whereContainer__1mduM","label-backgroundcolor":"WherePage_label-backgroundcolor__2wtTb","labelBackgroundcolor":"WherePage_label-backgroundcolor__2wtTb"};